/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import Imgix from 'js/components/Imgix';

import { Link, Typography2 } from '@coursera/cds-core';

import imgixParams from 'bundles/page/common/imgixParams';

const styles = {
  card: css`
    padding: var(--cds-spacing-50) var(--cds-spacing-200);
    vertical-align: top;
    text-align: left;
    display: flex;
    flex-direction: column;
  `,
  image: css`
    width: 100% !important;

    :hover {
      opacity: 0.8;
    }
  `,
  name: css`
    max-width: 175px;
    color: #0062e4;
  `,
};

type Props = {
  name: string;
  slug: string;
  logo: string | null;
  availability?: string | JSX.Element;
};

const Card = ({ logo, name, slug, availability }: Props) => {
  return (
    <Link css={styles.card} variant="standard" href={slug} data-e2e="partner-course-link">
      {logo && (
        <Imgix
          css={styles.image}
          src={logo}
          alt={name}
          maxWidth={175}
          maxHeight={175}
          imgParams={imgixParams.fillWithWhiteBackground}
          className="card-one-clicker"
        />
      )}
      <Typography2 component="p" css={styles.name} variant="bodyPrimary">
        {name}
      </Typography2>
      <Typography2 component="p" variant="bodySecondary" color="supportText">
        {availability}
      </Typography2>
    </Link>
  );
};

export default Card;
